<template>
  <div>
    <a-modal
      ref="modal"
      :title="'Quick Actions'"
      :footer="null"
      class="permission-modal"
      v-model="visible"
      @cancel="cancel"
      okText="Create"
    >
      <a-row class="pt-2" style="padding-bottom:40px">
        <a-col :span="11" class="mr-1 mt-2">
          <router-link :to="{name: 'users-create'}">
            <a-card class="actions--card">
              <a-row>
                <a-col :span="6" style="padding-top:14px">
                  <button class="actions--btn">
                    <a-icon type="team"/>
                  </button>
                </a-col>
                <a-col :span="18">
                  <span class="text-bold" style="font-size:13px">Users</span>
                  <br>
                  <span class="text-opacity" style="font-size:11px">Quickly Create a new Employee!</span>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
        <a-col :span="11" class="mr-1 mt-2">
          <router-link :to="{name: 'roles-create'}">
            <a-card class="actions--card">
              <a-row>
                <a-col :span="6" style="padding-top:14px">
                  <button class="actions--btn">
                    <a-icon type="share-alt"/>
                  </button>
                </a-col>
                <a-col :span="18">
                  <span class="text-bold" style="font-size:13px">Roles</span>
                  <br>
                  <span class="text-opacity" style="font-size:11px">Quickly Create a new Employee!</span>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
        <a-col :span="11" class="mr-1 mt-2">
          <router-link :to="{name: 'permissions-create'}">
            <a-card class="actions--card">
              <a-row>
                <a-col :span="6" style="padding-top:14px">
                  <button class="actions--btn">
                    <a-icon type="unlock"/>
                  </button>
                </a-col>
                <a-col :span="18">
                  <span class="text-bold" style="font-size:13px">Permissions</span>
                  <br>
                  <span class="text-opacity" style="font-size:11px">Quickly Create a new Employee!</span>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
        <a-col :span="11" class="mr-1 mt-2">
          <router-link :to="{name: 'account-show'}">
            <a-card class="actions--card">
              <a-row>
                <a-col :span="6" style="padding-top:14px">
                  <button class="actions--btn">
                    <a-icon type="user"/>
                  </button>
                </a-col>
                <a-col :span="18">
                  <span class="text-bold" style="font-size:13px">My Account</span>
                  <br>
                  <span class="text-opacity" style="font-size:11px">Manage your account information.</span>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
        <a-col :span="11" class="mr-1 mt-2">
          <a-card class="actions--card">
            <a-row>
              <a-col :span="6" style="padding-top:14px">
                <button class="actions--btn">
                  <a-icon type="logout"/>
                </button>
              </a-col>
              <a-col :span="18">
                <span class="text-bold" style="font-size:13px">Log out</span>
                <br>
                <span class="text-opacity" style="font-size:11px">Manage your account information.</span>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
    cancel() {
      this.$emit("cancel", false);
    }
  }
};
</script>
